exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-100p[data-v-ccfa559c]{height:100%}.wrapper[data-v-ccfa559c]{width:100%}.v-form[data-v-ccfa559c]{margin-top:2%}.wrapper_image[data-v-ccfa559c]{cursor:pointer;text-align:center}.wrapper_image span[data-v-ccfa559c]{color:#0032a0;font-weight:700}.wrapper-modal-actions[data-v-ccfa559c]{width:100%;text-align:center}.wrapper-modal-actions .v-btn[data-v-ccfa559c]{width:80%;margin-bottom:3%}.header-icon-wrapper[data-v-ccfa559c]{text-align:center;padding-top:20px}.header-icon-wrapper .v-icon[data-v-ccfa559c]{font-size:5rem}.wrapper-modal-title[data-v-ccfa559c]{text-align:center;margin-top:5%}.wrapper-modal-text[data-v-ccfa559c]{text-align:center}.actions-wrapper[data-v-ccfa559c]{width:100%;text-align:center}.actions-wrapper .v-btn[data-v-ccfa559c]{width:49%}.dialog-title[data-v-ccfa559c]{font-size:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ccfa559c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/createnewidentity/CreateNewIdentity.vue
// module id = 1032
// module chunks = 0